import { useState } from "react";
import { tiposProjeto, statusProjeto, ufs, responsaveis } from "@/mocks/projetos";

interface ProjectFiltersProps {
  onFilter: (filters: Record<string, string>) => void;
}

export default function ProjectFilters({ onFilter }: ProjectFiltersProps) {
  const [search, setSearch] = useState("");
  const [municipio, setMunicipio] = useState("");
  const [uf, setUf] = useState("");
  const [tipo, setTipo] = useState("");
  const [status, setStatus] = useState("");
  const [responsavel, setResponsavel] = useState("");
  const [showFilters, setShowFilters] = useState(false);

  const applyFilters = () => {
    onFilter({
      search: search.toLowerCase(),
      municipio: municipio.toLowerCase(),
      uf,
      tipo,
      status,
      responsavel,
    });
  };

  const clearFilters = () => {
    setSearch("");
    setMunicipio("");
    setUf("");
    setTipo("");
    setStatus("");
    setResponsavel("");
    onFilter({});
  };

  const hasFilters = search || municipio || uf || tipo || status || responsavel;

  return (
    <div className="bg-white rounded-card border border-background-200 p-4">
      {/* Search + Toggle */}
      <div className="flex items-center gap-2">
        <div className="flex-1 relative">
          <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-sm"></i>
          <input
            type="text"
            placeholder="Buscar por nome do projeto..."
            value={search}
            onChange={(e) => { setSearch(e.target.value); applyFilters(); }}
            className="w-full pl-9 pr-3 py-2 text-sm border border-background-200 rounded-btn focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 bg-background-50"
          />
        </div>
        <button
          onClick={() => setShowFilters(!showFilters)}
          className={`btn-outline text-xs px-3 py-2 cursor-pointer ${showFilters ? "border-primary-400 text-primary-600 bg-primary-50" : ""}`}
        >
          <i className="ri-filter-3-line"></i>
          Filtros
          {hasFilters && (
            <span className="ml-1 w-4 h-4 rounded-full bg-primary-500 text-white text-[10px] flex items-center justify-center">
              {[search, municipio, uf, tipo, status, responsavel].filter(Boolean).length}
            </span>
          )}
        </button>
        {hasFilters && (
          <button onClick={clearFilters} className="btn-outline text-xs px-3 py-2 cursor-pointer">
            <i className="ri-close-line"></i>
            Limpar
          </button>
        )}
      </div>

      {/* Expanded Filters */}
      {showFilters && (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 mt-3 pt-3 border-t border-background-200">
          <div>
            <label className="text-xs text-foreground-500 mb-1 block">Município</label>
            <input
              type="text"
              placeholder="Ex: Goiânia"
              value={municipio}
              onChange={(e) => { setMunicipio(e.target.value); applyFilters(); }}
              className="w-full px-3 py-2 text-sm border border-background-200 rounded-btn focus:outline-none focus:border-primary-400 bg-background-50"
            />
          </div>
          <div>
            <label className="text-xs text-foreground-500 mb-1 block">UF</label>
            <select
              value={uf}
              onChange={(e) => { setUf(e.target.value); applyFilters(); }}
              className="w-full px-3 py-2 text-sm border border-background-200 rounded-btn focus:outline-none focus:border-primary-400 bg-background-50"
            >
              <option value="">Todas</option>
              {ufs.map((u) => (
                <option key={u} value={u}>{u}</option>
              ))}
            </select>
          </div>
          <div>
            <label className="text-xs text-foreground-500 mb-1 block">Tipo de Projeto</label>
            <select
              value={tipo}
              onChange={(e) => { setTipo(e.target.value); applyFilters(); }}
              className="w-full px-3 py-2 text-sm border border-background-200 rounded-btn focus:outline-none focus:border-primary-400 bg-background-50"
            >
              <option value="">Todos</option>
              {tiposProjeto.map((t) => (
                <option key={t} value={t}>{t}</option>
              ))}
            </select>
          </div>
          <div>
            <label className="text-xs text-foreground-500 mb-1 block">Status</label>
            <select
              value={status}
              onChange={(e) => { setStatus(e.target.value); applyFilters(); }}
              className="w-full px-3 py-2 text-sm border border-background-200 rounded-btn focus:outline-none focus:border-primary-400 bg-background-50"
            >
              <option value="">Todos</option>
              {statusProjeto.map((s) => (
                <option key={s} value={s}>
                  {s === "em campo" ? "Em Campo" : s === "em revisao" ? "Em Revisão" : s.charAt(0).toUpperCase() + s.slice(1)}
                </option>
              ))}
            </select>
          </div>
          <div>
            <label className="text-xs text-foreground-500 mb-1 block">Responsável Técnico</label>
            <select
              value={responsavel}
              onChange={(e) => { setResponsavel(e.target.value); applyFilters(); }}
              className="w-full px-3 py-2 text-sm border border-background-200 rounded-btn focus:outline-none focus:border-primary-400 bg-background-50"
            >
              <option value="">Todos</option>
              {responsaveis.map((r) => (
                <option key={r} value={r}>{r}</option>
              ))}
            </select>
          </div>
        </div>
      )}
    </div>
  );
}